import { render } from "./App.vue?vue&type=template&id=38fe6664"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=38fe6664&lang=scss"

import exportComponent from "/home/wwwroot/h5-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__